import amplitude from 'amplitude-js';
import Bugsnag from './bugsnag';
import * as HubSpot from './HubSpot';
import Inspectlet from './Inspectlet';

declare global {
    interface Window {
        ga: any;
    }
}

amplitude.getInstance().init('48e9d13b8f50b1cebc4bf141b3f08146');

let eventContext = {};

interface UserMetadata {
    groupId?: number;
    groupName?: string;
}

export default {
    identify(id: string, name: string, email: string, { groupId, groupName }: UserMetadata = {}): void {

        const detailedName = groupName && groupId ?
            `group: '${groupName}' (${groupId}), user: '${name}'` :
            `user: ${name}`

        amplitude.getInstance().setUserId(id);
        amplitude.getInstance().regenerateDeviceId();

        amplitude
            .getInstance()
            .identify(new amplitude.Identify().set('name', name).set('email', email));

        HubSpot.identify(email);

        Bugsnag.setUser(id, email, detailedName);

        Inspectlet.identify(email);

        Inspectlet.tagSession({
            userId: id,
            username: email,
            email: email
        });
    },
    logout() {
        amplitude.getInstance().setUserId(null);
        amplitude.getInstance().regenerateDeviceId();
    },
    /** @deprecated use @vromo/analytics/tracking  */
    track(type: any, props: any = {}) {
        amplitude.getInstance().logEvent(type, { ...eventContext, ...props, host: location.host });

        if (window.ga) {
            window.ga(() => {
                window.ga.getAll().forEach((tracker: any) => {
                    tracker.set(props);
                    tracker.send('event', 'Vromo Event', type);
                });
            });
        }
    },
    setEventContext(context: any) {
        eventContext = context;
    },
    addEventContext(context: any) {
        eventContext = { ...eventContext, ...context };

        if (window.ga) {
            window.ga(() => {
                window.ga.getAll().forEach((tracker: any) => {
                    tracker.set(context);
                });
            });
        }
    }
};
